import { render, staticRenderFns } from "./IndustryForm.vue?vue&type=template&id=65a870c1&scoped=true"
import script from "./IndustryForm.vue?vue&type=script&lang=js"
export * from "./IndustryForm.vue?vue&type=script&lang=js"
import style0 from "./IndustryForm.vue?vue&type=style&index=0&id=65a870c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a870c1",
  null
  
)

export default component.exports